// src/features/distributionBoard/distributionBoardSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const DEFAULT_DISTRIBUTION_HEADERS = [
  'Circuito',
  'Marca',
  'Modelo',
  'In',
  'Calibre',
  'Longitud',
  'Descripción de Carga',
];

const DEFAULT_DISTRIBUTION_ROWS = ['1', '2-3', '4-5-6', '7'].map((circuito) => ({
  Circuito: circuito,
  Marca: '',
  Modelo: '',
  In: '',
  Calibre: '',
  Longitud: '',
  'Descripción de Carga': '',
}));

//
// Thunk to load the DistributionBoard node’s headerData/rowData into our slice,
// seeding a 3×3 empty grid if both arrays are initially empty.
//
export const buildDistributionBoard = createAsyncThunk(
  'distributionBoard/build',
  async (_, { getState, dispatch }) => {
    const { node } = getState();
    const nodeId = node.selectedNodeId;
    const target = node.nodes.find(n => n.id === nodeId);

    if (target && target.data.symbolLabel === 'DistributionBoard') {
      const hdrVal = target.data.attributes.headerData?.value;
      const rowVal = target.data.attributes.rowData?.value;

      let headers = Array.isArray(hdrVal) ? [...hdrVal] : [];
      let rows    = Array.isArray(rowVal) ? [...rowVal] : [];

      // Seed distribution-board defaults on first use
      if (headers.length === 0 && rows.length === 0) {
        headers = [...DEFAULT_DISTRIBUTION_HEADERS];
        rows = DEFAULT_DISTRIBUTION_ROWS.map((row) => ({ ...row }));
      }

      dispatch(setDistributionBoardConfig({ nodeId, headers, rows }));
    }
  }
);

const distributionBoardSlice = createSlice({
  name: 'distributionBoard',
  initialState: {
    nodeId:     null,
    headerData: [],
    rowData:    []
  },
  reducers: {
    // Load headers + rows into slice
    setDistributionBoardConfig(state, { payload }) {
      state.nodeId     = payload.nodeId;
      state.headerData = payload.headers;
      state.rowData    = payload.rows;
    },
    // Insert a new column
    addColumn(state, { payload: { after, header } }) {
      const idx = after != null
        ? state.headerData.indexOf(after) + 1
        : 0;
      state.headerData.splice(idx, 0, header);
      state.rowData.forEach(r => { r[header] = ''; });
    },
    // Insert a new row
    addRow(state, { payload: { after } }) {
      const newRow = state.headerData.reduce((o,h) => {
        o[h] = ''; return o;
      }, {});
      const idx = (after != null && Number.isInteger(after))
        ? after + 1
        : 0;
      state.rowData.splice(idx, 0, newRow);
    }
  },
  extraReducers: builder => {
    builder.addCase(buildDistributionBoard.fulfilled, () => {
      // nothing extra
    });
  }
});

export const { setDistributionBoardConfig, addColumn, addRow } =
  distributionBoardSlice.actions;
export default distributionBoardSlice.reducer;
